'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSpeakerNotesOff = function MdSpeakerNotesOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 3.4c1.8 0 3.2 1.4 3.2 3.2v20c0 1.8-1.4 3.3-3.2 3.4l-11.6-11.6h8.2v-3.4h-11.6l-1.6-1.6h13.2v-3.4h-13.4v3.2l-9.8-9.8h26.6z m-23.4 15h3.4l-3.4-3.4v3.4z m3.4 5v-3.4h-3.4v3.4h3.4z m-11.3-20.5l34.5 34.5-2.1 2.1-9.5-9.5h-15l-6.6 6.6v-28.2l-3.4-3.4z' })
        )
    );
};

exports.default = MdSpeakerNotesOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/speaker-notes-off.js
// module id = 3561
// module chunks = 0